import { TILE_LIBRARY_TYPES } from '../../../state/map/tiles/constants';
import SearchRegion from './SearchRegion';

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  [TILE_LIBRARY_TYPES.LEAFLET]: SearchRegion,
  [TILE_LIBRARY_TYPES.JSLA]: SearchRegion,
};
